import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Controller } from "../interface/controller.interface";
import { HTTPMethod } from "../model/http-method.enum";
import { HTTPRequestBuilder } from "../model/http.request.model";
import { HTTPService } from "./http.service";
import { orElse } from "../model/operator/or-else.operator";
import { CampaignZone } from "../persistence/dto/campaign-zone.model";

    /**
     * @description
     *  Servicio reflejo del controlador de zonas de campañas del backend.
     *
     * @see gigot-backend/Controllers/Sales/CampaignZonasController.cs
     */

@Injectable({ providedIn: "root" })
export class CampaignZoneService implements Controller {

    constructor(
        private httpService: HTTPService) {}

    public allZones(campaignId: number): Observable<CampaignZone[]> {
        return this.httpService.send<typeof undefined, CampaignZone[]>(
            new HTTPRequestBuilder()
                .method(HTTPMethod.GET)
                .controllerPath(this.basePath())
                .relativePath(`${campaignId}`)
                .build())
            .pipe(
                orElse<CampaignZone[]>([] as CampaignZone[]),
				map(campaignZones => campaignZones.map(campaignZone => CampaignZone.from(campaignZone))));
    }

    public basePath(): string {
        return "api/campaignZonas";
    }
}
